import ModaalTransformer from './ModaalTransformer';

const nodeSelector = 'node';

export default class Modaal {
  constructor(parent, selector) {
    const settings = {
      isGallery: parent.querySelectorAll('img').length > 1,
    };

    if (parent.classList.contains(nodeSelector)) {
      // Process individual node.
      parent.querySelectorAll(selector).forEach((child) => {
        settings.isVideo = child.parentNode.classList.contains('field-video');
        child.ConvertToModaal = new ModaalTransformer(child, settings);
      });
    } else {
      // Process group of nodes.
      parent.querySelectorAll(nodeSelector).forEach((node) => {
        node.querySelectorAll(selector).forEach((child) => {
          settings.isVideo = child.parentNode.classList.contains('field-video');
          child.ConvertToModaal = new ModaalTransformer(child, settings);
        });
      });
    }
  }
}
